import React, { useContext, useEffect, useState } from "react";
import Loading from "../../components/Genericos/Loading/Loading";
import "./Beneficios.css";
import FlechaIzquierdaIcon from "_+_Portal/assets/images/generico/FlechaIzquierdaIcon";
import MailIcon from "_+_Portal/assets/images/generico/MailIcon";
import RelojIcon from "_+_Portal/assets/images/generico/RelojIcon";
import WhatsAppIconColor from "_+_Portal/assets/images/generico/WhatsAppIconColor";
import PhoneCircleIcon from "_+_Portal/assets/images/generico/PhoneCircleIcon";
import HeaderbarBeneficios from "_+_Portal/components/Genericos/HeaderbarBeneficios/HeaderbarBeneficios";
import { hideModal, showModal } from "global/context/action/modal/modal";
import ModalInformacion from "./Modales/ModalInformacion";
import { GlobalContext } from "global/context/Provider";
import Modal from "global/component/Genericos/Modal/Modal";
import ModalAsociarme from "./Modales/ModalAsociarme";
import { useHistory } from "react-router";
import ModalLogueo from "./Modales/ModalLogueo";

const Beneficios = () => {
  const { authState, modalState, modalDispatch } = useContext(GlobalContext);
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [beneficioSelected, setBeneficioSelected] = useState(null);

  const history = useHistory();

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const modalMasInformacion = () => {
    showModal(
      <ModalInformacion dissmiss={dismiss} />,
      <>
        <p>Escribí tu dirección de e-mail para</p>
        <p>recibir más información.</p>
      </>,
      dismiss,
      false,
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const modalAsociarme = () => {
    if (authState.auth.data) {
      showModal(
        <ModalAsociarme dissmiss={dismiss} />,
        <>
          <span>Ingresá tu número de documento</span>
        </>,
        dismiss,
        false,
        {},
        "centro",
        true
      )(modalDispatch);
    } else {
      showModal(
        <ModalLogueo dissmiss={dismiss} />,
        <>
          <span>Atención</span>
        </>,
        dismiss,
        false,
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const dismiss = () => {
    hideModal()(modalDispatch);
  };

  const abrirBeneficios = (id) => {
    if (beneficioSelected === id) {
      setBeneficioSelected(null);
    } else {
      setBeneficioSelected(id);
    }
  };

  const arrayBeneficios = [
    {
      id: 0,
      titulo: "Beneficio Plata",
      listaBeneficios: (
        <ul>
          <li>10% en DIM.</li>
          <li>10% en óptica.</li>
          <li>Hasta un 40% en farmacias.</li>
          <li>Hasta un 40% en ortopedias.</li>
          <li>20% en asistencia al viajero de Universal Assistance.</li>
        </ul>
      ),
    },
    {
      id: 1,
      titulo: "Beneficio Oro",
      listaBeneficios: (
        <ul>
          <li>20% en DIM.</li>
          <li>20% en óptica.</li>
          <li>Hasta un 40% en farmacias.</li>
          <li>Hasta un 30% en ortopedias.</li>
          <li>30% en seguro médico de Sancor Seguros.</li>
          <li>20% en asistencia al viajero de Universal Assistance.</li>
          <li>Descuento en emergencias a domicilio con coseguro.</li>
        </ul>
      ),
    },
    {
      id: 2,
      titulo: "Beneficio Platino",
      listaBeneficios: (
        <ul>
          <li>30% en DIM.</li>
          <li>30% en óptica.</li>
          <li>Hasta un 40% en farmacias.</li>
          <li>Hasta un 30% en ortopedias.</li>
          <li>30% en seguro médico de Sancor Seguros.</li>
          <li>20% en asistencia al viajero de Universal Assistance.</li>
          <li>Descuento en emergencias a domicilio con coseguro.</li>
        </ul>
      ),
    },
  ];

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      <HeaderbarBeneficios
        onShowBurguerHandle={onShowBurguerHandle}
        beneficios={true}
      />
      <Loading descripcion="Verificando..." color="c-white" />
      <div className="ptur-beneficios-caja">
        {/* <div className="ptur-beneficios-rectanguloAzulGradient"></div> */}
        {/* <div className="ptur-beneficios-rectanguloAzul"></div> */}

        <div className="ptur-beneficios-login-imagen">
          <div className="ptur-beneficios-login">
            <p className="rb52b c-latex10">
              Asociate a nuestro programa de beneficios
            </p>
            <div className="ptur-beneficios-textos">
              <span className="rb16l c-latex10 ptur-beneficios-texto2">
                Contamos con un un programa de beneficios para que puedas
                acceder a los servicios de nuestros centros y a un paquete de
                descuentos exclusivos en los mejores comercios de la zona.
              </span>
            </div>

            <div className="ptur-beneficios-btnContainer">
              {Array.isArray(arrayBeneficios) &&
                arrayBeneficios.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="ptur-beneficios-preguntas rb16m"
                        onClick={() => abrirBeneficios(item.id)}
                      >
                        <div className="ptur-beneficios-titulo">
                          <p className="rb14b">{item.titulo}</p>
                          <span>
                            <div
                              className={
                                beneficioSelected === item.id
                                  ? "ptur-beneficios-flechaCerrar"
                                  : "ptur-beneficios-flechaAbrir"
                              }
                            >
                              <FlechaIzquierdaIcon />
                            </div>
                          </span>
                        </div>
                        {beneficioSelected === item.id && (
                          <>
                            <div className="ptur-beneficios-listaBeneficios rb16l">
                              {item.listaBeneficios}
                            </div>
                            <div className="ptur-beneficios-btnCardsContainer">
                              <button
                                className="ptur-beneficios-cardsBtn rb16m c-white bgc-primary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  modalAsociarme();
                                }}
                              >
                                Asociarme hoy
                              </button>
                              <button
                                className="ptur-beneficios-cardsBtn rb16m c-white bgc-latex30"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  modalMasInformacion();
                                }}
                              >
                                Mas Información
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </React.Fragment>
                  );
                })}
            </div>

            <div className="ptur-beneficios-cardContacto">
              <p className="c-white rb24b">Contacto</p>
              <hr className="lineaSepContacto" />
              <div className="ptur-beneficios-contactos">
                <div className="c-white iconoTexto">
                  <div className="whatsAppBox">
                    <WhatsAppIconColor width={40} height={40} />
                  </div>{" "}
                  Whatsapp:
                  <a href="https://www.google.com/">11-5509-3539</a>
                </div>
                <p className="c-white iconoTexto">
                  <PhoneCircleIcon /> Teléfono:{" "}
                  <a href="https://www.google.com/">5901-2121</a>
                </p>
                <p className="c-white iconoTexto">
                  <RelojIcon /> Lun-Vie 8 a 16h y Sáb 8 a 12h
                </p>
                <p className="c-white iconoTexto">
                  <MailIcon /> Email:{" "}
                  <a href="mailto: beneficios@dim.com.ar">
                    beneficios@dim.com.ar
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/*<div className="ptur-beneficios-boxImagenes">
            <div className="ptur-beneficios-rectanguloGrisGradient"></div>
            <img
              className="ptur-beneficios-imagenFondo"
              src={DIMPCR}
              alt="fondo logo"
            ></img>
          </div> */}
        {/* <img
          className="ptur-beneficios-imagenFondoMobile"
          src={DIMPCRMOBILE}
          alt="fondomobile logo"
        ></img> */}
        <div className="ptur-beneficios-footer">
          <img
            className="ptur-logoFooter"
            src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
            alt="logo"
          ></img>
          <hr className="barraNaranja" />
          <p className="c-white textoFooter">
            Te cuidamos hoy, con la
            <span className="rb16b">tecnología del mañana</span>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Beneficios;
